import React from 'react'

const StarContext = React.createContext();

export const StarProvider=({ children }) =>{
    const [isStarEnabled, setIsStarEnabled] = React.useState(false);

    return (
        <StarContext.Provider value={{isStarEnabled, setIsStarEnabled}}>
            {children}
        </StarContext.Provider>
    )
}

export default StarContext